import { render, staticRenderFns } from "./main-design.vue?vue&type=template&id=ce898222&scoped=true&"
import script from "./main-design.vue?vue&type=script&lang=js&"
export * from "./main-design.vue?vue&type=script&lang=js&"
import style0 from "./main-design.vue?vue&type=style&index=0&id=ce898222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce898222",
  null
  
)

export default component.exports